import React, { Component } from 'react';
import {FormattedHTMLMessage} from 'react-intl';
require(`../assets/${process.env.PAGE}/css/components/HowItWorks.css`);
import { Grid, Row, Col } from 'react-bootstrap';
import RequireLoanButton from '../components/RequireLoanButton.js';

class HowItWorks extends Component {

    showCodeField = () => {
        this.props.showCodeField(true);
    }

    render() {
        return (
            <div className="how_it_works">
                <Grid>
                    <Row className="how_it_works__row">
                         <Col sm={12} md={12} lg={12}>
                            <h2 onClick={this.showCodeField} className="how_it_works__title">Cómo funciona</h2>
                         </Col>
                    </Row>
                    <Row className="how_it_works__row">
                        <FormattedHTMLMessage
                                id="app.how_it_works"
                                defaultMessage="pasos"
                                description="Pasos a seguir"
                                values={{step_1_url: require(`../assets/${process.env.PAGE}/img/step-01.png`),
                                         step_2_url: require(`../assets/${process.env.PAGE}/img/step-02.png`),
                                         step_3_url: require(`../assets/${process.env.PAGE}/img/step-03.png`),
                                         step_4_url: require(`../assets/${process.env.PAGE}/img/step-04.png`)
                                        }}
                                />
                    </Row>
                    <Row className="how_it_works__row">
                         <Col sm={12} md={12} lg={12} className={"text-center"}>
                            <RequireLoanButton/>
                         </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

export default HowItWorks;



/** WEBPACK FOOTER **
 ** ./src/components/HowItWorks.js
 **/